<div
  (click)="onOpenSelectFiles()"
  class="select"
  [class.empty]="!urlForImg"
  [class.is-circle]="isCircle"
  [ngStyle]="{ 'border-radius': this.isCircle ? '50%' : '0', 'cursor': !block ? 'pointer' : 'auto' }">
  <input
    #input
    type="file"
    (change)="onSelectedFile($event.target['files'])"
    style="display: none"
    />
  <img loading="lazy"
    [src]="this.urlForImg || this.selectedFile || 'assets/images/icons/icons8-editar-imagen-100.png'"  alt=""/>
</div>
<div class="icon-edit-file" [class.is-selector-square]="!isCircle" (click)="onOpenSelectFiles()" *ngIf="!this.block && (this.urlForImg || this.selectedFile)">
    <span nz-icon nzType="edit" nzTheme="outline"></span>
</div>
